import { useEffect, useState,useCallback, useRef } from "react";
import { $CommonServiceFn } from "../../network/Services";
import  AoUrl  from '../../network/url';
import konsole from "../../network/konsole";
import { federal_way_plazaId, isNotValidNullUndefile, lplSubtinent,time_mattersSubtinent} from "../../control/Constant";
import BillingCenterTable from "./BillingCenterTable";
import { useNavigate,useLocation } from 'react-router-dom';
import moment from 'moment';
import BillingCenterTableNew from "./BillingCenterTableNew"



const BillingCenter = (props) => {
 const getLast7DaysDate = () => new Date(Date.now() - 6 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];
  const toDay = new Date().toISOString().split("T")[0]
  const [rowsOfPage] = useState(40);
  const [sortingCol, setSortingCol] = useState("REGISTRATIONDATE");
  const [sortType, setSortType] = useState("ASC");
  const [client, setClient] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [lastPage, setLastPage] = useState(2);
  const [searchText, setSearchText] = useState("");
  const [fetchByScroll, setByScroll] = useState(false);
  const [bulkopen, setBulkopen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [togglebtn, settogglebtn] = useState(false)
  const [enquiryMember, setEnquiryMember] = useState(false)
  const [emquiryMemberData, setEnquerymemberData] = useState([])
  const [filteredEnquiryMember, setFilteredEnquiryMember] = useState([])
//   const [image, takeScreenshot] = useScreenshot()
  const [render, setRender] = useState(false);
  const [isAmaPayment, setIsPayment] = useState(false);
  const [isFeeAgreementPayment, setIsFeeAgreementPayment] = useState(false);
  const [isPaymentOrderId, setIsPaymentOrderId] = useState(null);
  const [isPaymentStatus, setIsPaymentStatus] = useState(null)
  const [apiCallStoper, setapiCallStoper] = useState(false);
  const loggedInUserId = ''
  const [subtenantId,setSubtenantId] = useState()
  const [updateData, setUpdateData] = useState(false)
  const [isRotated, setIsRotated] = useState(false);
  const [excel, setExcel] = useState([])
  const [selectedCategoryIdParaList, setselectedCategoryIdParaList] = useState('Total_clients');
  const [isStateId, setIsStateId] = useState('1')
  const [isRender, setisRender] = useState(false)
  const [docName, setdocName] = useState('Total_clients.xlsx')
  const [finalSearchValue, setFinalSearchValue] = useState('')
  const [toggled, setToggled] = useState(false);
  const loggedUserData = ''
  const [directOpen,setDirectopen] = useState(false)
  const [timeMatter, setTimematter] = useState(null);
  const [toDateTable, setToDateTable] = useState();
  const [fromDateTable, setFromDateTable] = useState();
  const [staffId, setStaffId] = useState('')
  const [selectedUserId, setSelectedUserId] = useState()
  const navigate = useNavigate()
    const location = useLocation();
    const isUserScroll = useRef(false);



   const [today, setToday] = useState(new Date());
   
   function formatToYMD(date) {
    return [
     date.getFullYear(),
     String(date.getMonth() + 1).padStart(2, "0"),
     String(date.getDate()).padStart(2, "0")
       ].join("-");
     }
    
     useEffect(() => {
     const dayOfWeek = today.getDay();
     const mondayOffset = dayOfWeek === 1 ? 0 : -((dayOfWeek + 6) % 7);
     const from = new Date(today);
     from.setDate(today.getDate() + mondayOffset);
     setFromDateTable(formatToYMD(from));
     const to = new Date(from);
     to.setDate(from.getDate() + 6);
     setToDateTable(formatToYMD(to));
  
   }, []);

  useEffect(()=>{
  const currentUrl = window.location.href;
  const urlParams = new URLSearchParams(window.location.search);
  const subtenantId = urlParams.get('subtenantId');
  const value = subtenantId.replace(/\?.*$/, "");
  if(isNotValidNullUndefile(value)){
    setSubtenantId(value)
    setDirectopen(true)
  }else{
    let subtenantid = sessionStorage.getItem('SubtenantId')
    setSubtenantId(subtenantid)
    console.log(subtenantid,"subtenantidsubtenantid2")
    setDirectopen(false)
  }

  },[location?.search,subtenantId])


  useEffect(() => {
    getQueryParams()
    functionForAfterAmaPayment();
    // fetchApi()
  }, [])

  useEffect(() => {
    const isSecureMode = ''
    const toBoolean = (value) => String(value).toLowerCase() === "true";
    setToggled(toBoolean(isSecureMode))
  }, [toggled])

  // const handleToggle = (data) => {
  //   setToggled(!toggled);
  //   sessionStorage.setItem('secureMode', !toggled);
  //   if(toggled == true){
  //     setLoading(true)
  //   }
  // };

    // const fetchApi = useCallback(() => {
    // //   apiCallIfNeed(productPlans, fetchProductPlans());
    // }, [productPlans, dispatch]);

    // const apiCallIfNeed = useCallback((data, action) => {
    //   if (data.length > 0) return;
    //   dispatch(action);
    // }, [dispatch]);

  const functionHandleorderIdNStatus=(status,orderId)=>{
    setIsPaymentStatus(status)
    setIsPaymentOrderId(orderId)
  }

  const functionForAfterAmaPayment = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const trxnStatus = queryParams.get('TrxnStatus');
    const orderId = queryParams.get('OrderId');
    const amaUserEmail = sessionStorage.getItem('amaUser');
    const _isStateId = isStateId ? isStateId : sessionStorage.getItem('isStateId');
    const feeAgreementEmail = sessionStorage.getItem('feeAgreementUser');
    konsole.log("oramaUserEmailamaUserEmailderId", orderId, trxnStatus, amaUserEmail, feeAgreementEmail)
    if (isNotValidNullUndefile(orderId) && (isNotValidNullUndefile(amaUserEmail) || isNotValidNullUndefile(feeAgreementEmail))) {
      konsole.log("amaUserEmail", amaUserEmail, feeAgreementEmail, orderId, trxnStatus);
      setIsStateId(_isStateId);
      setLoading(true);
      // debugger
      // if(trxnStatus != 'SUCCESS'){
      //   // sessionStorage.setItem("amaUser",null)
      //   AlertToaster.error("Payment failed. Please try again.");
      // }
      functionHandleorderIdNStatus(trxnStatus,orderId)

      if (isNotValidNullUndefile(amaUserEmail)) {
        setIsFeeAgreementPayment(() => false);
        sessionStorage.setItem('amaUser', amaUserEmail);
        sessionStorage.setItem('searchItem', amaUserEmail);
        setIsPayment(() => true);
      } else if (isNotValidNullUndefile(feeAgreementEmail)) {
        setIsPayment(() => false);
        sessionStorage.setItem('feeAgreementUser', feeAgreementEmail);
        sessionStorage.setItem('searchItem', feeAgreementEmail);
        setIsFeeAgreementPayment(() => true);
      }
      const searchEmail = amaUserEmail || feeAgreementEmail;
      setSearchText(searchEmail);
      if(searchEmail){
      const newURL = window.location.pathname + `?toogle=2&search=` + encodeURIComponent(searchEmail)
      konsole.log("newURL", newURL)
      window.history.pushState({ path: newURL }, '', newURL);
      sessionStorage.setItem('searchItem', searchEmail);
      }
    } else {
      setLoading(true);
      functionHandleorderIdNStatus(null,null)
      setIsPayment(false)
      setIsFeeAgreementPayment(false)
      let searchData = sessionStorage.getItem('searchItem');
      setSearchText(searchData != 'null' ? searchData : ' ')
      const newURL = window.location.origin + window.location.pathname + `?toogle=${togglebtn == true ? 1 : 2}&search=` + encodeURIComponent(searchData == null ? '' : searchData);
      if (searchData == "") {
        const url = window.location.origin + window.location.pathname;
        // window.history.pushState({ path: url }, '', url);
      }
      else {
        // window.history.pushState({ path: newURL }, '', newURL);
      }
    }

    setTimeout(()=>{
      setRender(!render)
    },1000)
    handleKeypress(13)
    handleSearch()
    detectPageAndPerformActions()

  }

  const removeSearchText = () => {
    setSearchText('');
    sessionStorage.removeItem('searchItem')
  };

  useEffect(() => {
    return () => {
      removeSearchText();
    };
  }, []);

  const detectPageAndPerformActions = () => {
    const currentPage = window.location.href;
    // konsole.log("currentPage1233", currentPage, `${intakeBaseUrl}paralegal`)
    // if (currentPage.includes(`${intakeBaseUrl}paralegal`)) {
    //   // if (currentPage.includes("http://localhost:3000/paralegal")) {
    //   sessionStorage.removeItem("userDetailOfPrimary");
    // }
  };

  function GetQueryValues(param) {
    let url = "";
    let urlparam = [];
    url = window.location.href?.slice(window.location.href?.indexOf('?') + 1)?.split('&');
    for (let i = 0; i < url.length; i++) {
      urlparam = url[i]?.split('=');
      if (urlparam[0] == param) {
        return urlparam[1]?.split("#")?.[0] ?? "";
      }
    }
    return "";
  }


  // useEffect(() => {
  //   window.onpopstate = function () {
  //     location.reload();
  //   };
  // }, [])

  //code for enquiry member details---------------------------------------------------------------
  useEffect(() => {
    props?.setEnquiryMemberShow(enquiryMember)
  }, [enquiryMember])

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const trxnStatus = queryParams.get('TrxnStatus');
    if (trxnStatus) {
      setEnquiryMember(true)
      setLoading(true)
      settogglebtn(true)
    }
  }, [])

  function getQueryParams() {

    const queryParams = new URLSearchParams(window.location.search);
    const trxnStatus = queryParams.get('TrxnStatus');
    const orderId = queryParams.get('OrderId');
    konsole.log("trxnStatustrxnStatus",trxnStatus,orderId)
    // Using for upgrading member to intake after payment by card
    let upgradedMemberMail =JSON.parse(sessionStorage.getItem('enquirymemberDetails'));
    if(trxnStatus == 'SUCCESS' && isNotValidNullUndefile(upgradedMemberMail)){
      konsole.log("upgradedMemberMail",upgradedMemberMail)
      // upsertPlannerBook(orderId,upgradedMemberMail)
      // CallAfterUpgrade(upgradedMemberMail?.emailAddress)
      // sessionStorage.setItem('enquirymemberDetails',null)
    }
  }


  //code for enquiry member details---------------------------------------------------------------
  useEffect(() => {

    const isStateIdBySession = sessionStorage.getItem('isStateId');
    if (isStateIdBySession != '999999') {

      if(isNotValidNullUndefile(isStateIdBySession)){
        callapidata("","","",isStateIdBySession,undefined,selectedCategoryIdParaList);
      }else{

        callapidata("","","",isStateId);
      }

    } else {
      if (emquiryMemberData.length > 0) {
        // props.dispatchloader(true);
        const filteredData = emquiryMemberData.filter((item) => (item?.emailAddress?.toLowerCase()?.includes(searchText?.toLowerCase()) || item?.mobileNo?.includes(searchText) || item?.attendeeFullName?.toLowerCase()?.includes(searchText?.toLowerCase())));
        konsole.log("searchtext values", filteredData, searchText)
        // props.dispatchloader(false);
        setFilteredEnquiryMember(filteredData);
        setLoading(false)
      } else {
        // getEnqueryMember()
      }
    }
    if(loading==true){
      setUpdateData(true)
    }
  }, [loading,pageNumber,subtenantId,timeMatter]);

    const returnId =()=>{
      if(isNotValidNullUndefile(selectedUserId) && selectedUserId.length > 0 && selectedUserId !== false && selectedUserId != 'false'){
        return selectedUserId
      }else{
        return null
      }
    }



  const getSearchingValue = (loggedUserData,UpgradedClientMail,searchText,feeAgreementEmail) => {
    if (isNotValidNullUndefile(loggedUserData)) {return loggedUserData?.userEmail};
    if (isNotValidNullUndefile(UpgradedClientMail)) return UpgradedClientMail;
    if (isNotValidNullUndefile(searchText)) return searchText;
    if (isNotValidNullUndefile(feeAgreementEmail)) return feeAgreementEmail;
    return '';
  };

   const callapidata = async (UpgradedClientMail, filterData, id, newId, forcefulServicePlanId,fileNames) => {
     const loggedUserId = sessionStorage.getItem("loggedUserId");
     const searchText = decodeURIComponent(GetQueryValues("search"));
     const feeAgreementEmail = sessionStorage.getItem('feeAgreementUser') || sessionStorage.getItem('searchItem');
     const _pageNumber = fetchByScroll ? pageNumber : 1;
     const searchingVal = getSearchingValue(loggedUserData,UpgradedClientMail,searchText,feeAgreementEmail);

     const dayOfWeek = today.getDay();
     const mondayOffset = dayOfWeek === 1 ? 0 : -((dayOfWeek + 6) % 7);
 
     const from = new Date(today);
     from.setDate(today.getDate() + mondayOffset);
     const to = new Date(from);
     to.setDate(from.getDate() + 6);

     console.log(searchingVal,"searchingVal",loggedUserData,"1",UpgradedClientMail,"2",searchText,"3",feeAgreementEmail,"4",searchText,"searchText")
    console.log(subtenantId,"subtenantIdsubtenantIdsubtenantIdsubtenantId")
     setSearchText(decodeURI(searchingVal));

    //  if(!isNotValidNullUndefile(searchingVal)) return
    let inputData = {
      searchingText: searchingVal|| null,
      subtenantId: subtenantId,
      // startDate: isNotValidNullUndefile(fromDateTable) ? fromDateTable : null,
      // endDate: isNotValidNullUndefile(toDateTable) ? toDateTable : null,
      startDate: isNotValidNullUndefile(fromDateTable) ? fromDateTable : formatToYMD(from),
      endDate: isNotValidNullUndefile(toDateTable) ? toDateTable : formatToYMD(to),
      originatingStaffUserIds: staffId == 1 ?  returnId() : null,
      responsibleAttorneyUserIds: staffId == 2 ? returnId() : null,
      pageNumber: _pageNumber, //null
      rowsOfPage: rowsOfPage, // null
    }


    if (UpgradedClientMail || (loading) || filterData) {
      if (apiCallStoper) {
        setClient([]);
        setUpdateData(prev => !prev);
        return;
      }
      setLoading(!loading)
      inputData = {...inputData,...(fileNames == "Total AMA" ? { isAMA: true } : fileNames == "LPO" ? { roleId: "9" } : fileNames === "Intake" ? { roleId: "1,10" }: {}),
        // ...(isNotValidNullUndefile(isStateId) && !isNotValidNullUndefile(searchingVal) ? { servicePlanId: 1 } : {})
      };
      setapiCallStoper(true);
      props.setuseLoader(true);
        // let url = subtenantId == federal_way_plazaId ? AoUrl.getOrderDetailbySubtenantId : AoUrl.get_UserbyName;
        let url = subtenantId == federal_way_plazaId ? AoUrl.getOrderDetailbySubtenantId : AoUrl.getClientOrderList;
        let inputData989 = {
            "subtenantId": federal_way_plazaId,
            "pageNumber": _pageNumber,
            "rowsOfPage": 40,
            "searchField": searchingVal|| null,
            "isRecordDeatils": true,
            // "startDate": isNotValidNullUndefile(fromDateTable) ?  fromDateTable  : null,
            "startDate":isNotValidNullUndefile(fromDateTable) ? fromDateTable :   formatToYMD(from),
            // "endDate": isNotValidNullUndefile(toDateTable) ? toDateTable :  null,
            "endDate": isNotValidNullUndefile(toDateTable) ? toDateTable :  formatToYMD(to),
          }
        console.log(inputData,"inputDatainputDatainputDatainputData")
        let jsonObj = subtenantId == federal_way_plazaId ? inputData989 : inputData
        $CommonServiceFn.InvokeCommonApi("POST", url,jsonObj,(response)=>{
        const clientResponse = response?.data?.data || [];
        setClient([])
        let updatedClient = fetchByScroll ? [...client, ...clientResponse] : clientResponse;
        if(isNotValidNullUndefile(searchingVal) && toggled == true){
          setFinalSearchValue(searchingVal)
        }
        if (fetchByScroll) {
          setLastPage(clientResponse.length ? _pageNumber + 1 : _pageNumber);
          setClient(updatedClient);
          setByScroll(false);
        } else {
          if(isNotValidNullUndefile(loggedUserData)){
            const filterDatas = updatedClient?.filter((ele)=>ele?.memberId == loggedUserData?.userId)
            setClient(filterDatas);
          }else{
            setClient(updatedClient);
           }
          if( !isNotValidNullUndefile(fromDateTable)){
            setFromDateTable(formatToYMD(from));
            }
          if( !isNotValidNullUndefile(toDateTable)){
            setToDateTable(formatToYMD(to));
          }


          setUpdateData(prev => !prev);
          setByScroll(false);
          // setLoading(false);
        }
        setapiCallStoper(false);
        props.setuseLoader(false);
      })
    }


  };

  const scrollCallBack = (e) => {
  if (!isUserScroll.current) return;

  const node = e.target;
  if (!node || client?.length === 0) return;

  const { scrollTop, scrollHeight, clientHeight } = node;
  const scrollScreen = scrollTop + clientHeight;

  if (
    Math.ceil(scrollScreen) >= scrollHeight &&
    lastPage > pageNumber
  ) {
    setByScroll(true);
    setPageNumber(prev => prev + 1);
    setLoading(true);
  }
};


  const callApiAgain = () => {
    setLoading(true);
  }

  const handleSearch = () => {
    setPageNumber(1);
    if (isStateId == '999999') {
      setLoading(!loading);
    } else {
      setLoading(true);

    }
  };

  // const CallAfterUpgrade = (UpgradedClientMail, _isStateId) => {
  //   if(_isStateId) setIsStateId(_isStateId);
  //   settogglebtn(false)
  //   // setLoading(true)
  //   setselectedCategoryIdParaList("Total_clients")
  //   setEnquiryMember(false)
  //   setSearchText(UpgradedClientMail)
  //   const newURL = window.location.origin + window.location.pathname + `?toogle=${2}&search=` + encodeURIComponent(UpgradedClientMail);
  //   sessionStorage.setItem('searchItem',UpgradedClientMail)
  //   konsole.log("UpgradedClientMail",UpgradedClientMail)
  //   setByScroll(false);
  //   callapidata(UpgradedClientMail, undefined, undefined, undefined, _isStateId || undefined);
  //   // window.history.pushState({ path: newURL }, '', newURL);
  //   sessionStorage.setItem('enquirymemberDetails',null)

  // }

  const handleKeypress = (e) => {
    if (e.key == 'Enter') {
      setPageNumber(1);
      if(isNotValidNullUndefile(e.target?.value) || toggled == false){
        setLoading(!loading)}
        setLastPage(2);
    }
  };

  const [headerScrollInfo,setHeaderScrollInfo]=useState('');

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const toogleValue = searchParams.get('toogle')
    const toogleValueType = (toogleValue == null || toogleValue == 2) ? false : true
    settogglebtn(toogleValueType)
    setEnquiryMember(toogleValueType)
    setLoading(!loading)
    // const trxnStatus = queryParams.get('TrxnStatus');
  }, [])

  const returnToPayment = () => {
    // Get subtenantId directly from URL
    const urlParams = new URLSearchParams(window.location.search);
    let subId = urlParams.get('subtenantId');

    // If not in URL, get from state or sessionStorage
    if (!subId) {
      subId = subtenantId || sessionStorage.getItem('SubtenantId');
    }

    // Clean and convert to string
    subId = String(subId).replace(/\?.*$/, "");

    // Clear session storage
    sessionStorage.removeItem('companyName');
    sessionStorage.removeItem('SubtenantId');
    sessionStorage.removeItem('userDeatils');
    sessionStorage.removeItem('SessPrimaryUserId');

    // Set company and subtenantId based on subId
    if (subId == '2' || subId == '742') {
      sessionStorage.setItem('companyName', 'life_point_law');
      sessionStorage.setItem('SubtenantId', subId);
    } else if (subId == '3') {
      sessionStorage.setItem('companyName', 'aging_options');
      sessionStorage.setItem('SubtenantId', '3');
    } else if (subId == '989' || subId == '760') {
      sessionStorage.setItem('companyName', 'federal_way_plaza');
      sessionStorage.setItem('SubtenantId', subId);
    } else if (subId == '988') {
      sessionStorage.setItem('companyName', 'time_matters');
      sessionStorage.setItem('SubtenantId', '988');
    }

    navigate('/');
  }


  return (
    <div>

    {directOpen === true ? (
        <div className="pt-2 pb-2">
        <div className="w-full px-3">
            <div className="bg-white rounded shadow p-3 w-full">
            <div className="flex justify-between items-center w-full">
                <h1 className="text-lg font-bold text-gray-800">
                {
                    subtenantId == federal_way_plazaId
                    ? 'Federal Way Professional Plaza'
                    : subtenantId == time_mattersSubtinent
                    ? 'Time matters'
                    : subtenantId == lplSubtinent || subtenantId == 742
                    ? 'Life Point Law'
                    : 'Aging Options'
                } Payment Report
                </h1>

                <button
                className="btn-secondary ml-2 px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
                onClick={returnToPayment}
                >
                Back To Payment Screen
                </button>
            </div>
            </div>
        </div>
        </div>
    ) : ''}

      <div

       >
        {/* <BillingCenterTable key={isAmaPayment} dispatchloader={props.dispatchloader} isPaymentStatus={isPaymentStatus} isPaymentOrderId={isPaymentOrderId} functionHandleorderIdNStatus={functionHandleorderIdNStatus} client={client} setClient={setClient}
          isAmaPayment={isAmaPayment} isFeeAgreementPayment={isFeeAgreementPayment} onScrollBack={scrollCallBack} loading={loading} callapidata={callApiAgain} isStateId={isStateId} toggled={toggled} finalSearchValue={finalSearchValue}
          searchText={searchText} apiCallStoper={apiCallStoper}togglebtn={togglebtn}setIsStateId={setIsStateId}setSearchText={setSearchText} timeMatter={timeMatter} setTimematter={setTimematter}
          setPageNumber={setPageNumber}setLastPage={setLastPage}setLoading={setLoading} directOpen={directOpen} subtenantId={subtenantId} fromDateTable={fromDateTable} setFromDateTable={setFromDateTable} toDateTable={toDateTable} setToDateTable={setToDateTable}
          selectedUserId={selectedUserId} setSelectedUserId={setSelectedUserId} staffId={staffId} setStaffId={setStaffId} isUserScroll={isUserScroll} /> */}
           <BillingCenterTableNew key={isAmaPayment} dispatchloader={props.dispatchloader} isPaymentStatus={isPaymentStatus} isPaymentOrderId={isPaymentOrderId} functionHandleorderIdNStatus={functionHandleorderIdNStatus} client={client} setClient={setClient}
              isAmaPayment={isAmaPayment} isFeeAgreementPayment={isFeeAgreementPayment} onScrollBack={scrollCallBack} loading={loading} callapidata={callApiAgain} isStateId={isStateId} toggled={toggled} finalSearchValue={finalSearchValue}
              searchText={searchText} apiCallStoper={apiCallStoper}togglebtn={togglebtn}setIsStateId={setIsStateId}setSearchText={setSearchText} timeMatter={timeMatter} setTimematter={setTimematter}
              setPageNumber={setPageNumber}setLastPage={setLastPage}setLoading={setLoading} directOpen={directOpen} subtenantId={subtenantId} fromDateTable={fromDateTable} setFromDateTable={setFromDateTable} toDateTable={toDateTable} setToDateTable={setToDateTable}
              selectedUserId={selectedUserId} setSelectedUserId={setSelectedUserId} staffId={staffId} setStaffId={setStaffId} isUserScroll={isUserScroll} 
            />
      </div>


     </div>
  );
};

export default BillingCenter;
